(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const animations = new Set();
  let observer;
  const stop = () => {
    if (observer) observer.disconnect();
    animations.forEach((animation) => animation.cancel());
    animations.clear();
    document.body.classList.remove('studio-home-motion');
  };
  const init = () => {
    const home = document.querySelector('#MainContent[data-template="index"][data-studio-motion="true"]');
    if (!home || preference.matches || (window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
    document.body.classList.add('studio-home-motion');
    if (!observer) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          const animation = entry.target.animate([
            { opacity: 0, transform: 'translateY(18px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], { duration: 650, delay: Number(entry.target.dataset.studioDelay || 0), easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' });
          animations.add(animation);
          const clean = () => { animations.delete(animation); };
          animation.onfinish = clean;
          animation.oncancel = clean;
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });
    }
    const selector = '.studio-hero__content > *, .studio-ref-category, .studio-demo-product, .studio-home-tile, .studio-ref-lookbook__intro, .studio-ref-lookbook__image, .studio-section__heading';
    home.querySelectorAll(selector).forEach((element) => {
      if (seen.has(element)) return;
      seen.add(element);
      const index = Array.prototype.indexOf.call(element.parentElement.children, element);
      element.dataset.studioDelay = String(Math.min(index % 4, 3) * 75);
      observer.observe(element);
    });
  };
  preference.addEventListener('change', () => { if (preference.matches) stop(); else init(); });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
